import React, { useState } from "react";
import closeIcon from "../../../img/closeIcon.svg";
import useAuth from "../../../utils/CustomHooks/useAuth/useAuth";
import CustomSelect from "../../../utils/CustomSelect/CustomSelect";

const AddIndossamentModal = (props) => {
  const { onCloseModal, onHandleConfirmSelectedIndossament, isModalMessage } =
    props;

  const { dictionaryOrg, auth } = useAuth();
  // const [isEndoser, setEndoser] = useState(null);
  const isEndoser = auth.user?.organization;
  const [isEndossat, setEndossat] = useState(null);

  const optionOrg = dictionaryOrg.map((el) => ({
    value: el?.id,
    label: el?.name,
  }));

  return (
    <div className="add-indossament-modal__container">
      <div className="add-indossament-modal">
        <div className="add-indossament-modal__title">
          <h3>Indossament</h3>
          <img onClick={onCloseModal} src={closeIcon} alt={"иконка крестик"} />
        </div>
        <div className="add-indossament-modal-input-block">
          <label className="add-indossament-modal-input-block__label">
            Endoser
          </label>
          <p>{isEndoser?.name ?? "Loading"}</p>
          {/* <CustomSelect className="add-indossament-modal-input-block__input"
                                  options={optionOrg}
                                  value={isEndoser}
                                  onChange={value => setEndoser(value.value)}
                    /> */}
        </div>
        <div className="add-indossament-modal-input-block">
          <label className="add-indossament-modal-input-block__label">
            Endossat
          </label>
          <CustomSelect
            className="add-indossament-modal-input-block__input"
            options={optionOrg}
            value={isEndossat}
            onChange={(value) => setEndossat(value.value)}
          />
          <p className="add-indossament-modal-input-block__error-message">
            {isModalMessage}
          </p>
        </div>
        <div className="add-indossament-modal__buttons-block">
          <button
            onClick={() => onCloseModal()}
            className="add-indossament-modal__button-cancel"
            type={"button"}
          >
            Cancel
          </button>
          <button
            disabled={!isEndoser}
            onClick={() =>
              onHandleConfirmSelectedIndossament(isEndoser?.id, isEndossat)
            }
            className="add-indossament-modal__button-create"
            type={"button"}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};
export default AddIndossamentModal;
